import { t } from '@/features/i18n/utils';
import { createFileRoute } from '@tanstack/react-router';
import { artifactRevisionsQuery } from '@/features/artifacts/queries';
import { TimeQuarterPassIcon } from '@hugeicons-pro/core-stroke-rounded';
import { Icon } from '@/ui/components/icon';
import { BreadcrumbPage } from '@/ui/components/breadcrumb';
import { ProjectArtifactHeader } from '@/features/artifacts/components/artifact-header';
import { ArtifactVersionHistoryPage } from '@/features/artifacts/components/artifact-version-history-page';

export const Route = createFileRoute(
  '/_authed/project/$projectId/artifacts/$artifactId/version-history',
)({
  component: RouteComponent,
  loader: async ({ context, params }) => {
    await context.queryClient.infiniteQuery({
      ...artifactRevisionsQuery(params.artifactId),
      staleTime: 'static',
    });
  },
});

function RouteComponent() {
  const { artifactId } = Route.useParams();

  return (
    <>
      <ProjectArtifactHeader>
        <BreadcrumbPage>
          <Icon icon={TimeQuarterPassIcon} />
          {t({ en: 'Version history', nb: 'Versjonshistorikk' })}
        </BreadcrumbPage>
      </ProjectArtifactHeader>
      <ArtifactVersionHistoryPage artifactId={artifactId} />
    </>
  );
}
